export default __webpack_public_path__ + "static/media/5_image_4.bae81291.png";